export default function TermsPage() {
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-display text-4xl font-bold text-gray-900 mb-4">Terms of Service</h1>
      <div className="w-16 h-1 bg-brand-400 rounded-full mb-4" />
      <p className="text-sm text-gray-400 mb-10">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

      <div className="space-y-8 text-gray-600 leading-relaxed">
        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Chlolo Designs website, you agree to be bound by these
            Terms of Service. If you do not agree to these terms, please do not use our site.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">2. Products and Pricing</h2>
          <p>
            All prices are listed in US dollars and are subject to change without notice. We
            reserve the right to limit quantities and to refuse or cancel any order at our
            discretion. Product images are representative; slight color variations may occur
            due to monitor settings.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">3. Orders and Payment</h2>
          <p>
            By placing an order, you represent that you are authorized to use the payment
            method provided. All orders are subject to acceptance and availability. We will
            notify you if your order cannot be fulfilled.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">4. Shipping</h2>
          <p>
            We ship within 1–2 business days of receiving your order. Delivery times vary by
            location and carrier. We are not responsible for delays caused by shipping carriers
            or customs. Risk of loss passes to you upon delivery to the carrier.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">5. Returns and Refunds</h2>
          <p>
            We accept returns within 14 days of delivery for unused items in original condition.
            To initiate a return, contact us at{" "}
            <a href="mailto:hello@chlolodesigns.com" className="text-brand-600 hover:underline">
              hello@chlolodesigns.com
            </a>
            . Refunds are processed within 5–10 business days once we receive the returned item.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">6. Intellectual Property</h2>
          <p>
            All content on this site — including images, designs, text, and logos — is the
            property of Chlolo Designs and is protected by copyright law. You may not reproduce,
            distribute, or create derivative works without our express written permission.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">7. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Chlolo Designs shall not be liable for any
            indirect, incidental, special, or consequential damages arising from your use of
            this site or our products.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">8. Governing Law</h2>
          <p>
            These terms are governed by the laws of the jurisdiction in which Chlolo Designs
            operates, without regard to conflict of law principles.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">9. Contact</h2>
          <p>
            For questions about these Terms, please contact{" "}
            <a href="mailto:hello@chlolodesigns.com" className="text-brand-600 hover:underline">
              hello@chlolodesigns.com
            </a>
            .
          </p>
        </section>
      </div>
    </main>
  );
}
